import { FileUploadSection } from "./FileUploadSection";
import { FileUploadSectionV1 } from "./FileUploadSectionV1";
import { FileUploadSectionV2 } from "./FileUploadSectionV2";

export { FileUploadSection };
export { FileUploadSectionV1 };
export { FileUploadSectionV2 };
export default FileUploadSection;
